<template lang="pug">
#agrupamento
    .header
        h5 {{ cliente.nome }}
    .body
        .resultados(v-for='cpr in cliente.cprs', :key='cpr.id')
            resultado-pesquisa-accordion(:cpr='cpr')
</template>

<script>
import ResultadoPesquisaAccordion from './ResultadoPesquisaAccordion';
export default {
    name: 'AgrupamentoResultadoPesquisa',
    components: { ResultadoPesquisaAccordion },
    props: {
        cliente: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
$default-border-radius: 4px;

#agrupamento {
    margin-bottom: 20px;
    border: solid 1px var(--default-border-color);
    @include border-radius($default-border-radius);

    .header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--default-border-color);
        padding: 0 10px;
        height: 37px;
        background-color: #f5f5f5;
        @include border-radii(
            $default-border-radius,
            $default-border-radius,
            0,
            0
        );
    }

    .body {
        .resultados {
            border-bottom: 1px solid var(--default-border-color);
        }
    }
}
</style>
